import React, { useRef, useState } from 'react'
import { Table, Button } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import ListOperation from '@components/CRUD/ListOperation'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const List = () => {
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const { t } = useLocalization()

  const handleReload = () => {
    fetchRef.current.reload()
  }
  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const fetch = async ({ page, pageSize }) => {
    const result = await client
      .get('/specialist', {
        params: {
          skip: (page - 1) * pageSize,
          limit: pageSize,
        },
      })
      .then((res) => res.data)
    return result
  }

  const columns = [
    {
      title: t('specialty.listScreen.column.name'),
      dataIndex: 'name',
      key: 'name',
      width: '20%',
    },
    {
      title: t('specialty.listScreen.column.detail'),
      dataIndex: 'detail',
      key: 'detail',
      width: '10%',
    },
    {
      title: t('specialty.listScreen.column.action'),
      width: '10%',
      render: function Action(record) {
        return <ListOperation row={record} basePath="/specialties" />
      },
    },
  ]

  return (
    <Fetch fetch={fetch} params={{ page, pageSize }} ref={fetchRef}>
      {({ data, total }) => (
        <PageLayout
          title={t('specialty.listScreen.title')}
          createPath="/specialties/create"
          shownBack={false}
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('specialty.listScreen.reload')}
            </Button>,
          ]}
        >
          <Table
            rowKey="id"
            onChange={handleChange}
            columns={columns}
            dataSource={data}
            pagination={{
              defaultCurrent: defaultPageSize,
              defaultPageSize: defaultPageSize,
              current: page,
              pageSize,
              total,
            }}
          />
        </PageLayout>
      )}
    </Fetch>
  )
}

export default List
